import React from "react";
import GridContainer from "components/Grid/GridContainer";
import GridItem from "components/Grid/GridItem";
import Button from "components/CustomButtons/CustomButton";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import PrintIcon from "@material-ui/icons/PictureAsPdf";
import TableRowsIcon from "@material-ui/icons/TableChart";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";
import Typography from "@material-ui/core/Typography";

const COLORS = {
  main: "#13816F",
  headLight: "#19A58D",
  pastel1: "#CFF0EA",
  pastel2: "#E3F7F3",
  faded: "#F3FBF9",
};

const fmtMoney = (v) =>
  typeof v === "number"
    ? v.toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      })
    : Number(v || 0).toLocaleString(undefined, {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

export default function Coverage({
  title = "",
  info = {},
  forma = {},
  report_tz = "",
  timezones = {},
  onGeneratePdf,
  onGenerateCsv,
  onBack,
}) {
  return (
    <div className="container-fluid" style={{ padding: 20 }}>
      <form id="report_form">
        {forma &&
          Object.entries(forma).map(([field_name, field_value]) => (
            <input
              key={field_name}
              type="hidden"
              name={field_name}
              value={field_value}
              readOnly
            />
          ))}
      </form>
      <div className="cl-mcont">
        <GridContainer style={{ paddingTop: 20 }}>
          <GridItem xs={12}>
            <div
              className="block-flat"
              style={{ padding: 20, background: "#fff", borderRadius: 8 }}
            >
              {/* Header */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  <Typography variant="h6">
                    {report_tz
                      ? `${timezones?.[report_tz]} - ${report_tz.toUpperCase()}`
                      : ""}
                  </Typography>
                  <Typography variant="h5">{title}</Typography>
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(15, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(15, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              {/* Date + Company */}
              <GridContainer style={{ marginBottom: 20 }}>
                <GridItem xs={12} sm={2}>
                  Date: {new Date().toLocaleString()}
                </GridItem>
                <GridItem
                  xs={12}
                  sm={10}
                  style={{ textAlign: "right", fontSize: 20 }}
                >
                  HDI Seguros, S.A. de C.V.
                </GridItem>
              </GridContainer>
              {/* Main Table */}
              <TableContainer component={Paper}>
                <Table>
                  <TableBody>
                    {info.details &&
                      Object.entries(info.details).map(
                        ([row_name, row_val]) => {
                          return (
                            <React.Fragment key={row_name}>
                              <TableRow>
                                <TableCell
                                  colSpan={12}
                                  style={{
                                    background: COLORS.main,
                                    color: "#fff",
                                    fontWeight: 700,
                                  }}
                                >
                                  {row_name}
                                </TableCell>
                              </TableRow>
                              <TableRow style={{ textAlign: "center" }}>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  &nbsp;
                                </TableCell>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  Count
                                </TableCell>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  %
                                </TableCell>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  Net Prem
                                </TableCell>
                                <TableCell
                                  style={{
                                    background: COLORS.pastel1,
                                    color: "#000",
                                  }}
                                >
                                  %
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TableCell>
                                  <b>Coverage Analysis</b>
                                </TableCell>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell>&nbsp;</TableCell>
                              </TableRow>
                              {/* Coverage types */}
                              {row_val.coverage &&
                                row_val.coverage.type &&
                                Object.entries(row_val.coverage.type).map(
                                  ([idx, row]) => {
                                    if (
                                      row.term === "Excess Liability" ||
                                      row.term === "Liability" ||
                                      row.term === "Medical"
                                    ) {
                                      return (
                                        <React.Fragment key={row.term + idx}>
                                          <TableRow>
                                            <TableCell
                                              style={{ textAlign: "left" }}
                                            >
                                              {row.term}
                                            </TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                          </TableRow>
                                          {Object.entries(row.type).map(
                                            ([index_term, row_term]) => {
                                              return (
                                                <TableRow
                                                  key={
                                                    row_term.term + index_term
                                                  }
                                                  className="odd gradeX"
                                                  style={{ textAlign: "right" }}
                                                >
                                                  <TableCell
                                                    style={{
                                                      textAlign: "right",
                                                    }}
                                                  >
                                                    {row_term.term}
                                                  </TableCell>
                                                  <TableCell>
                                                    {row_term.count}
                                                  </TableCell>
                                                  <TableCell>
                                                    {row.count > 0
                                                      ? `${Math.round(
                                                          (row_term.count /
                                                            row.count) *
                                                            100
                                                        )}%`
                                                      : "0%"}
                                                  </TableCell>
                                                  <TableCell>
                                                    ${fmtMoney(row_term.net)}
                                                  </TableCell>
                                                  <TableCell>
                                                    {row.net > 0
                                                      ? `${Math.round(
                                                          (row_term.net /
                                                            row.net) *
                                                            100
                                                        )}%`
                                                      : "0%"}
                                                  </TableCell>
                                                </TableRow>
                                              );
                                            }
                                          )}
                                          <TableRow
                                            className="odd gradeX"
                                            style={{
                                              textAlign: "right",
                                              height:
                                                row.term === "Medical"
                                                  ? 35
                                                  : undefined,
                                            }}
                                          >
                                            <TableCell
                                              style={{ textAlign: "left" }}
                                            >
                                              Total {row.term}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                borderColor: "#000",
                                                borderWidth: "2px 0 0",
                                              }}
                                            >
                                              {row.count}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                borderColor: "#000",
                                                borderWidth: "2px 0 0",
                                              }}
                                            >
                                              {row_val.coverage.count > 0
                                                ? `${Math.round(
                                                    (row.count /
                                                      row_val.coverage.count) *
                                                      100
                                                  )}%`
                                                : "0%"}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                borderColor: "#000",
                                                borderWidth: "2px 0 0",
                                              }}
                                            >
                                              ${fmtMoney(row.net)}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                borderColor: "#000",
                                                borderWidth: "2px 0 0",
                                              }}
                                            >
                                              {row_val.coverage.net > 0
                                                ? `${Math.round(
                                                    (row.net /
                                                      row_val.coverage.net) *
                                                      100
                                                  )}%`
                                                : "0%"}
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      );
                                    } else {
                                      return (
                                        <TableRow
                                          key={row.term + idx}
                                          className="odd gradeX"
                                          style={{
                                            textAlign: "right",
                                            height:
                                              row.term ===
                                              "Accessories and Safety Gear"
                                                ? 35
                                                : undefined,
                                          }}
                                        >
                                          <TableCell
                                            style={{ textAlign: "left" }}
                                          >
                                            {row.term}
                                          </TableCell>
                                          <TableCell>{row.count}</TableCell>
                                          <TableCell>
                                            {row_val.coverage.count > 0
                                              ? `${Math.round(
                                                  (row.count /
                                                    row_val.coverage.count) *
                                                    100
                                                )}%`
                                              : "0%"}
                                          </TableCell>
                                          <TableCell>
                                            ${fmtMoney(row.net)}
                                          </TableCell>
                                          <TableCell>
                                            {row_val.coverage.net > 0
                                              ? `${Math.round(
                                                  (row.net /
                                                    row_val.coverage.net) *
                                                    100
                                                )}%`
                                              : "0%"}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  }
                                )}
                              <TableRow
                                className="odd gradeX"
                                style={{ textAlign: "right" }}
                              >
                                <TableCell style={{ textAlign: "left" }}>
                                  <b>Total Net Premium</b>
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderColor: "#000",
                                    borderWidth: "2px 0 2px 0",
                                  }}
                                >
                                  {row_val.coverage
                                    ? row_val.coverage.count
                                    : 0}
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderColor: "#000",
                                    borderWidth: "2px 0 2px 0",
                                  }}
                                >
                                  {row_val.coverage &&
                                  row_val.coverage.count > 0
                                    ? "100%"
                                    : "0%"}
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderColor: "#000",
                                    borderWidth: "2px 0 2px 0",
                                  }}
                                >
                                  $
                                  {fmtMoney(
                                    row_val.coverage ? row_val.coverage.net : 0
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderColor: "#000",
                                    borderWidth: "2px 0 2px 0",
                                  }}
                                >
                                  {row_val.coverage && row_val.coverage.net > 0
                                    ? "100%"
                                    : "0%"}
                                </TableCell>
                              </TableRow>
                              {/* Discount Applied */}
                              <TableRow>
                                <TableCell>Discount Applied</TableCell>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell>&nbsp;</TableCell>
                                <TableCell>&nbsp;</TableCell>
                              </TableRow>
                              {row_val.special_discount &&
                                row_val.special_discount?.type &&
                                Object.entries(
                                  row_val.special_discount?.type
                                ).map(([idx, row]) => {
                                  return (
                                    <React.Fragment key={row.term + idx}>
                                      <TableRow>
                                        <TableCell>{row.term}</TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                        <TableCell></TableCell>
                                      </TableRow>
                                      {Object.entries(row.type).map(
                                        ([index_term, row_term]) => {
                                          return (
                                            <TableRow
                                              key={row_term.term + index_term}
                                              className="odd gradeX"
                                              style={{ textAlign: "right" }}
                                            >
                                              <TableCell
                                                style={{ textAlign: "right" }}
                                              >
                                                {row_term.term}
                                              </TableCell>
                                              <TableCell>
                                                {row_term.count}
                                              </TableCell>
                                              <TableCell>
                                                {row_val.special_discount
                                                  ?.count > 0
                                                  ? `${Math.round(
                                                      (row_term.count /
                                                        row_val.special_discount
                                                          ?.count) *
                                                        100
                                                    )}%`
                                                  : "0%"}
                                              </TableCell>
                                              <TableCell>
                                                ${fmtMoney(row_term.net)}
                                              </TableCell>
                                              <TableCell>
                                                {row_val.special_discount?.net >
                                                0
                                                  ? `${Math.round(
                                                      (row_term.net /
                                                        row_val.special_discount
                                                          ?.net) *
                                                        100
                                                    )}%`
                                                  : "0%"}
                                              </TableCell>
                                            </TableRow>
                                          );
                                        }
                                      )}
                                      <TableRow
                                        className="odd gradeX"
                                        style={{ textAlign: "right" }}
                                      >
                                        <TableCell
                                          style={{ textAlign: "left" }}
                                        >
                                          Total {row.term}
                                        </TableCell>
                                        <TableCell>{row.count}</TableCell>
                                        <TableCell>
                                          {row_val.special_discount?.count > 0
                                            ? `${Math.round(
                                                (row.count /
                                                  row_val.special_discount
                                                    ?.count) *
                                                  100
                                              )}%`
                                            : "0%"}
                                        </TableCell>
                                        <TableCell>
                                          ${fmtMoney(row.net)}
                                        </TableCell>
                                        <TableCell>
                                          {row_val.special_discount?.net > 0
                                            ? `${Math.round(
                                                (row.net /
                                                  row_val.special_discount
                                                    ?.net) *
                                                  100
                                              )}%`
                                            : "0%"}
                                        </TableCell>
                                      </TableRow>
                                    </React.Fragment>
                                  );
                                })}
                              <TableRow
                                className="odd gradeX"
                                style={{ textAlign: "right" }}
                              >
                                <TableCell style={{ textAlign: "left" }}>
                                  <b>Total Long Term Policies</b>
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderColor: "#000",
                                    borderWidth: "2px 0 2px 0",
                                  }}
                                >
                                  {row_val.special_discount
                                    ? row_val.special_discount?.count
                                    : 0}
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderColor: "#000",
                                    borderWidth: "2px 0 2px 0",
                                  }}
                                >
                                  {row_val.special_discount &&
                                  row_val.special_discount?.count > 0
                                    ? "100%"
                                    : "0%"}
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderColor: "#000",
                                    borderWidth: "2px 0 2px 0",
                                  }}
                                >
                                  $
                                  {fmtMoney(
                                    row_val.special_discount
                                      ? row_val.special_discount?.net
                                      : 0
                                  )}
                                </TableCell>
                                <TableCell
                                  style={{
                                    borderColor: "#000",
                                    borderWidth: "2px 0 2px 0",
                                  }}
                                >
                                  {row_val.special_discount &&
                                  row_val.special_discount?.net > 0
                                    ? "100%"
                                    : "0%"}
                                </TableCell>
                              </TableRow>
                            </React.Fragment>
                          );
                        }
                      )}
                    {/* Totales */}
                    <TableRow>
                      <TableCell
                        colSpan={12}
                        style={{
                          background: COLORS.main,
                          color: "#fff",
                          fontWeight: 700,
                        }}
                      >
                        Total
                      </TableCell>
                    </TableRow>
                    <TableRow style={{ textAlign: "center" }}>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        &nbsp;
                      </TableCell>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        Count
                      </TableCell>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        %
                      </TableCell>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        Net Prem
                      </TableCell>
                      <TableCell
                        style={{ background: COLORS.pastel1, color: "#000" }}
                      >
                        %
                      </TableCell>
                    </TableRow>
                    {info.totales &&
                      Object.entries(info.totales).map(
                        ([row_name, row_val]) => {
                          if (row_val.term === "Coverage") {
                            return (
                              <React.Fragment key={row_name}>
                                <TableRow>
                                  <TableCell>
                                    <b>Coverage Analysis</b>
                                  </TableCell>
                                  <TableCell>&nbsp;</TableCell>
                                  <TableCell>&nbsp;</TableCell>
                                  <TableCell>&nbsp;</TableCell>
                                  <TableCell>&nbsp;</TableCell>
                                </TableRow>
                                {Object.entries(row_val.type).map(
                                  ([idx, row]) => {
                                    if (
                                      row.term === "Excess Liability" ||
                                      row.term === "Liability" ||
                                      row.term === "Medical"
                                    ) {
                                      return (
                                        <React.Fragment key={row.term + idx}>
                                          <TableRow>
                                            <TableCell
                                              style={{ textAlign: "left" }}
                                            >
                                              {row.term}
                                            </TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                            <TableCell></TableCell>
                                          </TableRow>
                                          {Object.entries(row.type).map(
                                            ([index_term, row_term]) => (
                                              <TableRow
                                                key={row_term.term + index_term}
                                                className="odd gradeX"
                                                style={{ textAlign: "right" }}
                                              >
                                                <TableCell
                                                  style={{ textAlign: "right" }}
                                                >
                                                  {row_term.term}
                                                </TableCell>
                                                <TableCell>
                                                  {row_term.count}
                                                </TableCell>
                                                <TableCell>
                                                  {row.count > 0
                                                    ? `${Math.round(
                                                        (row_term.count /
                                                          row.count) *
                                                          100
                                                      )}%`
                                                    : "0%"}
                                                </TableCell>
                                                <TableCell>
                                                  ${fmtMoney(row_term.net)}
                                                </TableCell>
                                                <TableCell>
                                                  {row.net > 0
                                                    ? `${Math.round(
                                                        (row_term.net /
                                                          row.net) *
                                                          100
                                                      )}%`
                                                    : "0%"}
                                                </TableCell>
                                              </TableRow>
                                            )
                                          )}
                                          <TableRow
                                            className="odd gradeX"
                                            style={{
                                              textAlign: "right",
                                              height:
                                                row.term === "Medical"
                                                  ? 35
                                                  : undefined,
                                            }}
                                          >
                                            <TableCell
                                              style={{ textAlign: "left" }}
                                            >
                                              Total {row.term}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                borderColor: "#000",
                                                borderWidth: "2px 0 0",
                                              }}
                                            >
                                              {row.count}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                borderColor: "#000",
                                                borderWidth: "2px 0 0",
                                              }}
                                            >
                                              {row_val.count > 0
                                                ? `${Math.round(
                                                    (row.count /
                                                      row_val.count) *
                                                      100
                                                  )}%`
                                                : "0%"}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                borderColor: "#000",
                                                borderWidth: "2px 0 0",
                                              }}
                                            >
                                              ${fmtMoney(row.net)}
                                            </TableCell>
                                            <TableCell
                                              style={{
                                                borderColor: "#000",
                                                borderWidth: "2px 0 0",
                                              }}
                                            >
                                              {row_val.net > 0
                                                ? `${Math.round(
                                                    (row.net / row_val.net) *
                                                      100
                                                  )}%`
                                                : "0%"}
                                            </TableCell>
                                          </TableRow>
                                        </React.Fragment>
                                      );
                                    } else {
                                      return (
                                        <TableRow
                                          key={row.term + idx}
                                          className="odd gradeX"
                                          style={{
                                            textAlign: "right",
                                            height:
                                              row.term ===
                                              "Accessories and Safety Gear"
                                                ? 35
                                                : undefined,
                                          }}
                                        >
                                          <TableCell
                                            style={{ textAlign: "left" }}
                                          >
                                            {row.term}
                                          </TableCell>
                                          <TableCell>{row.count}</TableCell>
                                          <TableCell>
                                            {row_val.count > 0
                                              ? `${Math.round(
                                                  (row.count / row_val.count) *
                                                    100
                                                )}%`
                                              : "0%"}
                                          </TableCell>
                                          <TableCell>
                                            ${fmtMoney(row.net)}
                                          </TableCell>
                                          <TableCell>
                                            {row_val.net > 0
                                              ? `${Math.round(
                                                  (row.net / row_val.net) * 100
                                                )}%`
                                              : "0%"}
                                          </TableCell>
                                        </TableRow>
                                      );
                                    }
                                  }
                                )}
                                <TableRow
                                  className="odd gradeX"
                                  style={{
                                    textAlign: "right",
                                    borderColor: "#000",
                                    borderWidth: "2px 2px 0",
                                  }}
                                >
                                  <TableCell style={{ textAlign: "left" }}>
                                    <b>Total Net Premium</b>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderColor: "#000",
                                      borderWidth: "2px 0 2px 0",
                                    }}
                                  >
                                    {row_val.net ? row_val.count : 0}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderColor: "#000",
                                      borderWidth: "2px 0 2px 0",
                                    }}
                                  >
                                    {row_val.count > 0 ? "100%" : "0%"}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderColor: "#000",
                                      borderWidth: "2px 0 2px 0",
                                    }}
                                  >
                                    ${fmtMoney(row_val.net ? row_val.net : 0)}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderColor: "#000",
                                      borderWidth: "2px 0 2px 0",
                                    }}
                                  >
                                    {row_val.net > 0 ? "100%" : "0%"}
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            );
                          } else {
                            return (
                              <React.Fragment key={row_name}>
                                <TableRow>
                                  <TableCell>Discount Applied</TableCell>
                                  <TableCell>&nbsp;</TableCell>
                                  <TableCell>&nbsp;</TableCell>
                                  <TableCell>&nbsp;</TableCell>
                                  <TableCell>&nbsp;</TableCell>
                                </TableRow>
                                {Object.entries(row_val.type).map(
                                  ([idx, row]) => {
                                    return (
                                      <React.Fragment key={row.term + idx}>
                                        <TableRow>
                                          <TableCell>{row.term}</TableCell>
                                          <TableCell></TableCell>
                                          <TableCell></TableCell>
                                          <TableCell></TableCell>
                                          <TableCell></TableCell>
                                        </TableRow>
                                        {Object.entries(row.type).map(
                                          ([index_term, row_term]) => {
                                            return (
                                              <TableRow
                                                key={row_term.term + index_term}
                                                className="odd gradeX"
                                                style={{ textAlign: "right" }}
                                              >
                                                <TableCell
                                                  style={{ textAlign: "right" }}
                                                >
                                                  {row_term.term}
                                                </TableCell>
                                                <TableCell>
                                                  {row_term.count}
                                                </TableCell>
                                                <TableCell>
                                                  {row_val.count > 0
                                                    ? `${Math.round(
                                                        (row_term.count /
                                                          row_val.count) *
                                                          100
                                                      )}%`
                                                    : "0%"}
                                                </TableCell>
                                                <TableCell>
                                                  ${fmtMoney(row_term.net)}
                                                </TableCell>
                                                <TableCell>
                                                  {row_val.net > 0
                                                    ? `${Math.round(
                                                        (row_term.net /
                                                          row_val.net) *
                                                          100
                                                      )}%`
                                                    : "0%"}
                                                </TableCell>
                                              </TableRow>
                                            );
                                          }
                                        )}
                                        <TableRow
                                          className="odd gradeX"
                                          style={{ textAlign: "right" }}
                                        >
                                          <TableCell
                                            style={{ textAlign: "left" }}
                                          >
                                            Total {row.term}
                                          </TableCell>
                                          <TableCell>{row.count}</TableCell>
                                          <TableCell>
                                            {row_val.count > 0
                                              ? `${Math.round(
                                                  (row.count / row_val.count) *
                                                    100
                                                )}%`
                                              : "0%"}
                                          </TableCell>
                                          <TableCell>
                                            ${fmtMoney(row.net)}
                                          </TableCell>
                                          <TableCell>
                                            {row_val.net > 0
                                              ? `${Math.round(
                                                  (row.net / row_val.net) * 100
                                                )}%`
                                              : "0%"}
                                          </TableCell>
                                        </TableRow>
                                      </React.Fragment>
                                    );
                                  }
                                )}
                                <TableRow
                                  className="odd gradeX"
                                  style={{
                                    textAlign: "right",
                                    borderColor: "#000",
                                    borderWidth: "2px 2px 0",
                                  }}
                                >
                                  <TableCell style={{ textAlign: "left" }}>
                                    <b>Total Long Term Policies</b>
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderColor: "#000",
                                      borderWidth: "2px 0 2px 0",
                                    }}
                                  >
                                    {row_val.count}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderColor: "#000",
                                      borderWidth: "2px 0 2px 0",
                                    }}
                                  >
                                    {row_val.count > 0 ? "100%" : "0%"}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderColor: "#000",
                                      borderWidth: "2px 0 2px 0",
                                    }}
                                  >
                                    ${fmtMoney(row_val.net)}
                                  </TableCell>
                                  <TableCell
                                    style={{
                                      borderColor: "#000",
                                      borderWidth: "2px 0 2px 0",
                                    }}
                                  >
                                    {row_val.net > 0 ? "100%" : "0%"}
                                  </TableCell>
                                </TableRow>
                              </React.Fragment>
                            );
                          }
                        }
                      )}
                  </TableBody>
                </Table>
              </TableContainer>
              {/* Bottom Buttons */}
              <GridContainer style={{ marginBottom: 16 }}>
                <GridItem xs={12} sm={6}>
                  &nbsp;
                </GridItem>

                <GridItem xs={12} sm={6}>
                  <GridContainer>
                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<PrintIcon />}
                        onClick={() => onGeneratePdf(15, "pdf")}
                        style={{ width: "100%" }}
                      >
                        PDF
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        variant="green"
                        startIcon={<TableRowsIcon />}
                        onClick={() => onGenerateCsv(15, "csv")}
                        style={{ width: "100%" }}
                      >
                        CSV
                      </Button>
                    </GridItem>

                    <GridItem xs={12} sm={4}>
                      <Button
                        style={{
                          background: "#FFF",
                          borderColor: COLORS.main,
                          color: COLORS.main,
                          border: "1px solid",
                          width: "100%",
                        }}
                        startIcon={<ArrowBackIcon />}
                        onClick={onBack}
                      >
                        Back To Reports
                      </Button>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
            </div>
          </GridItem>
        </GridContainer>
      </div>
    </div>
  );
}
